// copied from packages/ui/src/components/FlavorFinder/components/ResultSuggestionCard/index.ts
export * from "./FlavorFinderResultSuggestionCard";
